import { CHANGE_LANGUAGE, FETCH_LANGUAGES, GET_LANGUAGES } from '../actions/types.js'

const selectedLanguage = localStorage.getItem('language')?.toLowerCase()
const userLang = selectedLanguage || navigator.language || navigator.userLanguage
const defaultLocale = userLang.substring(0, 2)

const initialState = {
  language: defaultLocale,
  isLoading: false,
  languages: [],
}

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case CHANGE_LANGUAGE:
      localStorage.setItem('language', action.payload?.toLowerCase())
      return {
        ...state,
        language: action.payload,
      }
    case FETCH_LANGUAGES:
      return {
        ...state,
        isLoading: true,
      }
    case GET_LANGUAGES:
      return {
        ...state,
        isLoading: false,
        languages: action.payload,
      }
    default:
      return state
  }
}
